import angular from "angular";
import dcInstructorFooterNav from "./instructor-footer-nav.directive";
export default angular
  .module("instructor.directives.footernav", [])
  .directive("dcInstructorFooterNav", dcInstructorFooterNav);
